module.exports = __webpack_public_path__ + "static/media/ab_2.500898a8.png";